<div class="bodyHeight">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-6  col-xl-5">
        <!-- <div class="img-out">
                  <img src="./assets/resources/img/Ahyush_Logo.png" class="mx-auto d-block" alt="awlm-logo">
                </div> -->

        <div class="border forBoarder" *ngIf="confirmStatus">
          <div class="login-lable">
            <div class="text-center CreatedPassword">{{message}}!</div>
          </div>
          <div class="text-center forLogin">Please click below to login</div>

          <div class="text-center forLoginButtion">
            <a> <button type="button" class="RGARRButton" (click)="key_service?.login()">LOGIN</button></a>
          </div>

        </div>
        <div class="border forBoarder " *ngIf="!confirmStatus">
          <div class="login-lable">
            <div class="text-center CreatedPassword">OOPS!</div>
          </div>
          <div class="text-center forLogin">Internal server error</div>

          <div class="text-center forLoginButtion">
            <a [routerLink]="['/login']" [queryParams]="{redirectTo:''}"> <button type="button" class="RGARRButton">LOGIN</button></a>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>